function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from "react";
import { goldCoin, load, ticket } from "./svg";
import useData from "./data";
import AspectBanner from "../../Common/AspectBanner";
import { isAdani, isReloy } from "../../../utils/isClient";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Ledger = function Ledger(_ref) {
  var config = _ref.config,
    winnreAuth = _ref.winnreAuth,
    winnreNoAuth = _ref.winnreNoAuth,
    appType = _ref.appType,
    redux = _ref.redux,
    router = _ref.router,
    SkeletonMyRewardPoints = _ref.SkeletonMyRewardPoints,
    formatCoins = _ref.formatCoins,
    Modal = _ref.Modal,
    _ref$showAppDownload = _ref.showAppDownload,
    showAppDownload = _ref$showAppDownload === void 0 ? false : _ref$showAppDownload;
  var _useState = useState(3),
    _useState2 = _slicedToArray(_useState, 2),
    viewMore = _useState2[0],
    setViewMore = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    showTooltip = _useState4[0],
    setShowTooltip = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isMobile = _useState6[0],
    setIsMobile = _useState6[1];
  var _useData = useData({
      winnreAuth: winnreAuth,
      redux: redux,
      router: router,
      appType: appType
    }),
    loading = _useData.loading,
    pointActivitiesList = _useData.pointActivitiesList,
    setLoadMore = _useData.setLoadMore,
    totalPages = _useData.totalPages;
  var history = router.history;
  console.log("config darkMode", config === null || config === void 0 ? void 0 : config.darkMode);
  console.log("config darkTheme", config === null || config === void 0 ? void 0 : config.darkTheme);
  // console.log("pointActivitiesList", pointActivitiesList);

  // Handle responsive detection
  useEffect(function () {
    var checkMobile = function checkMobile() {
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    checkMobile();

    // Add event listener for window resize
    window.addEventListener("resize", checkMobile);

    // Cleanup
    return function () {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);
  var handleViewMore = function handleViewMore() {
    setViewMore(function (prev) {
      return prev + 3;
    });
  };
  var reloyRewardPoints = redux.reloyRewardPoints;
  var isAuthenticated = redux === null || redux === void 0 ? void 0 : redux.isAuthenticated;
  var darkMode = config === null || config === void 0 ? void 0 : config.darkMode;
  var isReloyClient = isReloy(config);
  var isAdaniClient = isAdani(config);
  // Background URLs based on device
  var bgUrls = {
    bg1: isMobile ? "https://cdn.loyalie.in/1774367746480_Ledger_B1M" : "https://cdn.loyalie.in/1774257142945_LedgerB2W",
    bg2: darkMode ? isMobile ? "https://cdn.loyalie.in/1786014004257_tht_ledger_mob" : "https://cdn.loyalie.in/1786013934773_tht_ledger" : isMobile ? isAdaniClient ? "https://cdn.loyalie.in/connectre_website/COJ-Coin-Ledger-Mob-banner.png" : "https://cdn.loyalie.in/1774517949067_ledgerG_BM" : isAdaniClient ? "https://cdn.loyalie.in/connectre_website/COJ-Coin-Ledger-banner.png" : "https://cdn.loyalie.in/1774256858798_LedgerB1W"
  };
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(showAppDownload ? 'pb-16' : ""),
    children: isAuthenticated && /*#__PURE__*/_jsxs("div", {
      className: "w-full md:pl-3 lg:pl-7 2xl:pl-7 pb-10",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex flex-col md:flex-row items-center gap-2 mb-8",
        children: [/*#__PURE__*/_jsx("div", {
          className: "w-full md:w-[35%] relative h-[30vh] md:h-[50vh] overflow-hidden rounded-t-2xl md:rounded-t-none md:rounded-tl-2xl md:rounded-bl-2xl ".concat(isAdaniClient && 'bg-white border-[2px] border-primary', " "),
          style: {
            backgroundImage: "url(\"".concat(!isAdaniClient && bgUrls.bg1, "\")"),
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          },
          children: /*#__PURE__*/_jsxs("div", {
            className: "absolute inset-0 flex flex-col justify-center p-6 xl:p-10 text-center md:text-left ".concat(config !== null && config !== void 0 && config.darkTheme ? 'text-black' : ''),
            children: [/*#__PURE__*/_jsxs("div", {
              className: "space-y-1 lg:space-y-0 xl:space-y-1 pb-6",
              children: [/*#__PURE__*/_jsx("p", {
                className: "text-lg xl:text-xl",
                children: "You have earned"
              }), /*#__PURE__*/_jsxs("div", {
                className: "flex flex-row items-center  justify-center lg:items-start lg:flex-col",
                children: [/*#__PURE__*/_jsxs("p", {
                  className: "text-3xl lg:text-4xl xl:text-5xl tracking-wide ".concat(config === null || config === void 0 ? void 0 : config.fontTitle, " ").concat(isAdaniClient && 'text-primary', " leading-[1]"),
                  children: [reloyRewardPoints != null ? reloyRewardPoints.toLocaleString("en-IN") : '', " "]
                }), /*#__PURE__*/_jsxs("p", {
                  className: "text-2xl xl:text-4xl ".concat(config === null || config === void 0 ? void 0 : config.fontTitle, " ").concat(isAdaniClient && 'text-primary', " leading-[1] ml-2 lg:ml-0 "),
                  children: [" ", /*#__PURE__*/_jsx("span", {
                    children: isReloyClient ? 'HT Points' : 'Insider Coins'
                  })]
                })]
              })]
            }), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsxs("button", {
                onClick: function onClick() {
                  return history.push("/rewardPointStore");
                },
                className: " border-[2px]  py-1 px-3 lg:px-2 xl:px-3 text-sm font-medium ".concat(isAdaniClient ? 'border-primary text-primary font-medium' : 'border-black'),
                children: ["REDEEM ", /*#__PURE__*/_jsx("span", {
                  children: isReloyClient ? 'POINTS' : 'COINS'
                })]
              })
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "w-full md:w-[70%] relative h-[60vh] md:h-[50.5vh] overflow-hidden p-[2px]",
          children: /*#__PURE__*/_jsx("div", {
            className: "relative w-full h-full overflow-hidden ".concat(config !== null && config !== void 0 && config.darkMode ? "" : "rounded-b-[12px] lg:rounded-b-none lg:rounded-br-[20px]  lg:rounded-tr-[20px]", " ").concat(isAdaniClient && 'border-[2px] border-primary'),
            children: config !== null && config !== void 0 && config.darkMode ? /*#__PURE__*/_jsx("img", {
              src: bgUrls.bg2,
              alt: "Ledger Banner",
              className: "w-full h-full object-fill cursor-pointer",
              onClick: function onClick() {
                return history.push(isReloyClient ? "/refer" : "/gift-and-earn");
              }
            }) : /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx("div", {
                className: "absolute inset-0",
                style: {
                  backgroundImage: "url(\"".concat(bgUrls.bg2, "\")"),
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat"
                }
              }), /*#__PURE__*/_jsxs("div", {
                className: "absolute inset-0 flex flex-col gap-4 lg:gap-0 lg:justify-between  p-8 lg:p-6 xl:p-10 text-center md:text-left",
                children: [/*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsxs("p", {
                    className: "text-xl lg:text-2xl xl:text-3xl font-medium leading-[1] ".concat(isAdaniClient ? 'text-white' : 'bg-gradient-to-br from-[#fccc7e] via-[#ffeed4] to-[#bf9b62] bg-clip-text text-transparent', " "),
                    children: ["Refer and earn", " ", /*#__PURE__*/_jsx("span", {
                      className: "hidden md:inline",
                      children: /*#__PURE__*/_jsx("br", {})
                    }), "300 insider coins", /*#__PURE__*/_jsx("br", {})]
                  }), /*#__PURE__*/_jsx("p", {
                    className: "text-xl lg:text-2xl xl:text-3xl font-medium text-white leading-[1]",
                    children: "on each submission"
                  })]
                }), appType !== "winnre" && /*#__PURE__*/_jsx("div", {
                  children: /*#__PURE__*/_jsx("button", {
                    className: "border-[1px]  py-1 px-3 text-sm  ".concat(isAdaniClient ? 'text-white border-white' : 'border-primary-focus bg-gradient-to-br from-[#fccc7e] via-[#ffeed4] to-[#bf9b62] bg-clip-text text-transparent', " "),
                    onClick: function onClick() {
                      return history.push("/gift-and-earn");
                    },
                    children: "REFER NOW"
                  })
                }), /*#__PURE__*/_jsxs("p", {
                  className: "text-base md:text-md text-white font-light mb-32 lg:mb-0 leading-[1] ".concat(isAdaniClient && 'hidden lg:block', " "),
                  children: ["To learn more about how coins are earned,", " ", /*#__PURE__*/_jsx("span", {
                    className: "text-lg font-medium cursor-pointer ".concat(isAdaniClient ? 'text-white' : 'bg-gradient-to-br from-[#fccc7e] via-[#ffeed4] to-[#bf9b62] bg-clip-text text-transparent', " "),
                    onClick: function onClick() {
                      return history.push("/rewardPointStore");
                    },
                    children: "Click Here"
                  })]
                })]
              })]
            })
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "mb-8 ",
        children: /*#__PURE__*/_jsx("h2", {
          className: "text-2xl lg:text-3xl font-normal ".concat(config === null || config === void 0 ? void 0 : config.fontTitle, " text-center md:text-left "),
          children: "Transaction History"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "mx-auto",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "grid grid-cols-4 text-sm font-semibold  ".concat(config !== null && config !== void 0 && config.darkMode ? 'text-gray-300' : 'text-gray-700', " mb-3 px-4"),
          children: [/*#__PURE__*/_jsx("div", {
            children: "Sl. No."
          }), /*#__PURE__*/_jsx("div", {
            children: "Date"
          }), /*#__PURE__*/_jsx("div", {
            children: "Details"
          }), /*#__PURE__*/_jsx("div", {
            className: "text-right",
            children: isReloyClient ? 'HT Points' : 'Insider Coins'
          })]
        }), pointActivitiesList && pointActivitiesList.length > 0 && pointActivitiesList.map(function (item, index) {
          var dateObj = new Date(item.updatedOn);
          var formattedDate = dateObj.toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
          }).replace(/(\d{2} \w{3}) (\d{4})/, "$1, $2");
          var isEarn = item.type === "EARN";
          return /*#__PURE__*/_jsxs("div", {
            className: "bg-white border shadow-md mb-4 p-2 md:p-4 grid grid-cols-4 items-center",
            children: [/*#__PURE__*/_jsx("div", {
              children: index + 1
            }), /*#__PURE__*/_jsx("div", {
              children: formattedDate
            }), /*#__PURE__*/_jsx("div", {
              children: item.reason
            }), /*#__PURE__*/_jsx("div", {
              className: "text-right",
              children: /*#__PURE__*/_jsxs("span", {
                className: isEarn ? "text-green-500 font-bold" : "text-red-500 font-bold",
                children: [isEarn ? "+" : "-", item.points]
              })
            })]
          }, index);
        }), !totalPages > 1 && /*#__PURE__*/_jsxs("button", {
          onClick: function onClick() {
            return setLoadMore(function (prev) {
              return prev + 8;
            });
          },
          className: "flex items-center justify-center gap-x-2 mx-auto  mt-6 border-[1px] border-black py-2 px-10 text-md text-black",
          children: [/*#__PURE__*/_jsx("span", {
            className: "text-sm  font-Roboto",
            children: " VIEW MORE"
          }), load]
        })]
      }), loading && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "mb-6",
          children: _toConsumableArray(Array(1).keys()).map(function (n) {
            return /*#__PURE__*/_jsx(SkeletonMyRewardPoints, {}, n);
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "mt-6 mb-6",
          children: _toConsumableArray(Array(1).keys()).map(function (n) {
            return /*#__PURE__*/_jsx(SkeletonMyRewardPoints, {}, n);
          })
        })]
      })]
    })
  });
};
export default Ledger;